var MARK_START = String.fromCharCode(0x2063); // invisible separator - marks the start of a tagged string
var MARK_END = String.fromCharCode(0x2064); // invisible plus - ends the encoded key index, value follows
var BIT0 = String.fromCharCode(0x200B); // zero width space
var BIT1 = String.fromCharCode(0x200C); // zero width non-joiner
var REGISTRY_KEY = "__inlineTextKeys";
/** The window-scoped registry mapping marker indices to their i18n keys. Deduped by key so the same
    key used in many places shares one index (editing it updates every occurrence, which is correct). */
export function getKeyRegistry(win) {
    var w = win;
    if (!w[REGISTRY_KEY])
        w[REGISTRY_KEY] = { keys: [], byKey: {} };
    return w[REGISTRY_KEY];
}
function indexForKey(reg, key) {
    var existing = reg.byKey[key];
    if (existing !== undefined)
        return existing;
    var idx = reg.keys.length;
    reg.keys.push(key);
    reg.byKey[key] = idx;
    return idx;
}
/** Wrap a translated value with the invisible marker for its key. Returns the value unchanged when it
    is already tagged or empty. */
export function tagText(win, key, value) {
    if (!value || value.charAt(0) === MARK_START)
        return value;
    var idx = indexForKey(getKeyRegistry(win), key);
    var bits = idx.toString(2).split("").map(function (b) { return (b === "1" ? BIT1 : BIT0); }).join("");
    return MARK_START + bits + MARK_END + value;
}
export function readTag(win, text) {
    if (!text)
        return null;
    var start = text.indexOf(MARK_START);
    if (start < 0)
        return null;
    var end = text.indexOf(MARK_END, start);
    if (end < 0)
        return null;
    var bits = text.substring(start + 1, end);
    var idx = 0;
    for (var i = 0; i < bits.length; i++)
        idx = (idx << 1) | (bits.charAt(i) === BIT1 ? 1 : 0);
    var reg = getKeyRegistry(win);
    var key = reg.keys[idx];
    if (key === undefined)
        return null;
    return { key: key, value: text.substring(end + 1), index: start };
}
/** Strip any marker from a string, leaving the clean visible value (marker may sit anywhere). */
export function stripTag(text) {
    if (!text)
        return text;
    var start = text.indexOf(MARK_START);
    if (start < 0)
        return text;
    var end = text.indexOf(MARK_END, start);
    return end < 0 ? text : text.substring(0, start) + text.substring(end + 1);
}
